<script>
  import { page } from '@inertiajs/svelte';
  import ContactsForm from '$lib/contacts/Form.svelte';
  import Footer from './Index.svelte';
  import FooterBottom from './Bottom.svelte';

  $: footer = $page.props.footer;
</script>

<Footer>
  <div class="gradient--royal">
    <div class="container">
      <div class="footer__inner text-center">
        <img
          class="footer__inner-logo"
          width="50"
          height="50"
          src={footer.bottom.logo.src}
          alt={footer.bottom.logo.alt}
        />
        <h2 class="footer__title">{footer.main.title}</h2>
        <p class="footer__desc">{footer.main.desc}</p>
      </div>

      <ContactsForm />
    </div>

    <FooterBottom data={footer.bottom} type="contacts" />
  </div>
</Footer>

<style lang="scss">
  :global .footer {
    color: rgb(var(--white));

    &__inner {
      padding: 10rem 0 0;

      @include resp-max('s') {
        padding: 5rem 0 0;
      }

      &-logo {
        margin: 0 auto;

        @include resp-max('s') {
          height: 8rem;
        }
      }
    }

    &__title {
      @include resp-max('s') {
        margin-top: 1rem;
      }
    }

    &__desc {
      @include resp-max('s') {
        margin-top: 1rem;
        color: var(--royal-light);
      }
    }
  }
</style>
